import { Card, CardContent, CardHeader, CardTitle } from '@dataroom/shared';

/**
 * How the room's documents are processed — the owner-approved statement
 * (2026-10-20), kept word for word. Plain information: no toggle, no setting.
 * The same wording is on the marketing site (site/how-we-handle-documents/).
 */
export const DOCUMENT_HANDLING_STATEMENT =
  "ClosingVault never sends your documents to a free AI chatbot. To file documents automatically, ClosingVault uses one contracted classification service, which does not use your documents to train AI. Reading scanned pages, redaction and search all run on ClosingVault's own servers.";

export function DocumentHandlingCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>How this room&apos;s documents are processed</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm" data-testid="document-handling-statement">
          {DOCUMENT_HANDLING_STATEMENT}
        </p>
      </CardContent>
    </Card>
  );
}
